<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaDoencas"
        title-table="Doenças CID"
        module="doencasCidSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_DOENCA_CID_INSERIR'"
        :view-permission="'ROLE_DOENCA_CID_CONSULTAR'"
        :edit-permission="'ROLE_DOENCA_CID_ATUALIZAR'"
        :delete-permission="'ROLE_DOENCA_CID_DELETAR'"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormDoencaCid
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormDoencaCid from './forms/FormDoencaCid.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormDoencaCid,
  },
  computed: {
    ...mapState('doencasCidSettingsModule', {
      listaDoencas: state => state.listaDoencas,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Especialidade',
          field: 'especialidade.descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('doencasCidSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('doencasCidSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
